import React from 'react';
import Button from '../ui/Button';

export default function HubupQuotaExhaustedBanner({ onViewOffers }) {
  return (
    <div
      className="mx-4 md:mx-6 lg:mx-8 mt-4 rounded-lg border border-red-300 bg-red-50 text-red-900 px-4 py-3 text-sm flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
      role="alert"
    >
      <div>
        <p className="font-medium">Cette communauté n&apos;a plus de notifications disponibles.</p>
      </div>
      {onViewOffers ? (
        <Button
          type="button"
          size="sm"
          className="shrink-0 w-full sm:w-auto bg-red-900 hover:bg-red-950 text-white"
          onClick={onViewOffers}
        >
          Voir les offres
        </Button>
      ) : null}
    </div>
  );
}
